import GenericModel from '../generic-model';
import Employee from '../product/employee';

export default class Branch extends GenericModel {
  name?: string;
  employees?: Employee[];
}
